<template>
  <b-row>
    <b-col>
      <h3>{{ $t('general.posArticleNumberList') }}</h3>
      <textarea disabled :value="posArticleNumberListWithNewLines"></textarea>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "PosArticleList",
  props: {
    posArticleNumberList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    /**
     * Format posArticleNumberList (JSON array) so each item is on its own line
     */
    posArticleNumberListWithNewLines() {
      const list = this.posArticleNumberList;
      if (Array.isArray(list)) {
        return list.join('\n');
      }
      return list;
    }
  }
}
</script>
